module.exports = __webpack_public_path__ + "img/sbw.12f7082c.jpg";